import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

let supabase: SupabaseClient | null = null;

if (supabaseUrl && supabaseAnonKey) {
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: false,
    },
  });
} else {
  console.warn(
    'Supabase environment variables are missing. Contact form submissions will be disabled until VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are configured.'
  );
}

export { supabase };
export const isSupabaseConfigured = Boolean(supabase);

